import CashnetPage from './index'

export default CashnetPage
